var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.getMainClasses]},[_c('nuxt',{attrs:{"keep-alive":""}}),_c('utils')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }